import { render, staticRenderFns } from "./CheckboxItem.vue?vue&type=template&id=1a5e8cde&"
import script from "./CheckboxItem.vue?vue&type=script&lang=ts&"
export * from "./CheckboxItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sush/Virtual/cublic-form-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a5e8cde')) {
      api.createRecord('1a5e8cde', component.options)
    } else {
      api.reload('1a5e8cde', component.options)
    }
    module.hot.accept("./CheckboxItem.vue?vue&type=template&id=1a5e8cde&", function () {
      api.rerender('1a5e8cde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resource/component/form/Field/CheckboxItem.vue"
export default component.exports